export const createHeadline = ({ headlineTitle }) => headlineTitle || 'Home Design Service';
